import { Box, Flex, Input } from "@chakra-ui/react";
import { Typography } from "@reconvert/react-ui-component";
import { CloseFilled } from "@reconvert/react-ui-component/icons";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";

interface ProductTitleSelectorProps {
  titleText: string;
  value: string;
  setTitleValue: (data: { value: string }) => void;
  placeholder?: string;
  isWhiteSpaceAllowed?: boolean;
  warningMessage?: string;
  fieldError?: string;
}

const ProductTextSelector = ({ titleText, value, setTitleValue, placeholder, isWhiteSpaceAllowed, warningMessage, fieldError }: ProductTitleSelectorProps) => {
  const { t } = useTranslation();
  const [showWarning, setShowWarning] = useState(false);
  const [touched, setTouched] = useState(false);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value;
    
    if (isWhiteSpaceAllowed === false && /\s/.test(inputValue)) {
      setShowWarning(true);
    } else {
      setShowWarning(false);
    }
    
    setTitleValue({ value: inputValue });
  };

  return (
    <Box mt={2}>
      <Flex gap={1} flexDirection={"column"}>
        <Typography color={"#6A7381"} width={"max-content"} bg={"var(--Natural-100, #F9FAFC)"} variant="small">
          {t(titleText)}
        </Typography>
        <Input 
          value={value} 
          onChange={handleInputChange} 
          placeholder={placeholder}
          borderColor={showWarning && touched ? "red.500" : undefined}
          isInvalid={touched && !!fieldError}
          onBlur={() => setTouched(true)}
          onFocus={() => setTouched(false)}
        />
        {fieldError && touched && (
          <Flex alignItems="center" gap="4px">
            <CloseFilled width="12px" height="12px" color="error.700" />
            <Typography variant="small" color="red.500" mt={0.5}>
              {fieldError}
            </Typography>
          </Flex>
        )}
        {showWarning && touched && (
          <Typography color={"red.500"} variant="small">
            {warningMessage}
          </Typography>
        )}
      </Flex>
    </Box>
  );
};

export default ProductTextSelector;
